const CLASSES = {
  trigger: "scroll-trigger",
  offscreen: "scroll-trigger--offscreen",
  cancel: "scroll-trigger--cancel",
  zoom: "animate--zoom-in",
  design: "scroll-trigger--design-mode",
};

// Scroll-in animation
function onIntersection(entries, observer) { 
  for (const entry of entries) {
    const el = entry.target;
    if (entry.isIntersecting) {
      el.classList.remove(CLASSES.offscreen);
      if (el.hasAttribute("data-cascade")) {
        el.style.setProperty("--animation-order", entry.target.dataset.index || 0);
      }
      observer.unobserve(el);
    } else {
      el.classList.add(CLASSES.offscreen);
      el.classList.remove(CLASSES.cancel);
    }
  }
}

function initializeScrollAnimationTrigger(root = document, designMode = false) {
  const els = [...root.getElementsByClassName(CLASSES.trigger)];
  if (!els.length) return;

  if (designMode) {
    els.forEach((el) => el.classList.add(CLASSES.design));
    return;
  }

  const observer = new IntersectionObserver(onIntersection, { rootMargin: "0px 0px -50px 0px" });
  els.forEach((el, i) => {
    el.dataset.index = i;
    observer.observe(el);
  });
}

// Zoom-in animation
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const els = [...document.getElementsByClassName(CLASSES.zoom)];
  if (!els.length) return;

  const scaleAmount = 0.002; // 0.2 / 100

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const el = entry.target;
      updateZoom(el);
      window.addEventListener("scroll", throttle(() => updateZoom(el)), { passive: true });
    }
  });

  els.forEach((el) => observer.observe(el));

  function updateZoom(el) {
    el.style.setProperty("--zoom-in-ratio", 1 + scaleAmount * percentageSeen(el));
  }
}

function percentageSeen(el) {
  const viewportH = innerHeight;
  const scrollY = window.scrollY;
  const rect = el.getBoundingClientRect();
  const elTop = rect.top + scrollY;
  const elH = el.offsetHeight;

  if (elTop > scrollY + viewportH) return 0;
  if (elTop + elH < scrollY) return 100;

  const distance = scrollY + viewportH - elTop;
  return Math.round(distance / ((viewportH + elH) / 100));
}

// Simple throttle (nếu chưa có)
function throttle(fn, wait = 100) {
  let last = 0;
  return (...args) => {
    const now = Date.now();
    if (now - last >= wait) {
      last = now;
      fn(...args);
    }
  };
}

window.addEventListener("DOMContentLoaded", () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener("shopify:section:load", (e) => initializeScrollAnimationTrigger(e.target, true));
  document.addEventListener("shopify:section:reorder", () => initializeScrollAnimationTrigger(document, true));
}
